import api from "../services/api";
import { stringToDate } from "../hooks/utils/useFormat";

export default async function getSurvey(props) {
  const { query, config, trainee_id } = props;
  const _today = new Date();
  const formatSurvey = __survey => {
    const _trainee_vote =
      __survey?.surveyAnswer?.find(__answer => __answer.trainee_id === trainee_id)?.survey_option_id || null;
    let _survey = {
      ...__survey,
      only_admin_edit: !!__survey.user_id,
      expires_date: stringToDate(__survey.expires_date),
      voted: _trainee_vote,
      event_id: __survey.event_id,
      surveyOptions: __survey?.surveyOptions?.map(__option => ({
        ...__option,
        votes_percent:
          (__survey.surveyAnswer?.filter(__option_val => __option_val.survey_option_id === __option.id)?.length /
            __survey.surveyAnswer?.length) *
            100 || 0,
      })),
      status: !__survey.open
        ? "Cancelada"
        : stringToDate(__survey.expires_date) < _today && __survey.expires_date !== null
        ? "Finalizada"
        : !trainee_id
        ? "Ativa"
        : !_trainee_vote
        ? "Aguardando Voto"
        : "Votada",
    };
    _survey.surveyOptions.sort((__a, __b) => {
      return __b.votes_percent - __a.votes_percent;
    });
    return _survey;
  };
  let { data: _survey } = await api.get(`${!!trainee_id ? "trainee/" : ""}survey${query}`, config);
  if (!!_survey?.data) _survey.data = _survey.data?.map(__survey => formatSurvey(__survey)) || [];
  else _survey = formatSurvey(_survey);
  return _survey;
}
